import { z } from "zod/v4-mini";

import { ApiDataSourceSpec, apiDataSource } from "@/io/datasource/ApiDatasource.ts";
import { FileModel, fileSchema } from "@/models/FileModel.ts";
import { GeneratePrescriptionData, Prescription } from "@/models/PrescriptionGenerationModel.ts";

/**
 * Generate a prescription
 */
export class PrescriptionRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  generatePrescription = (data: GeneratePrescriptionData): Promise<Prescription> => {
    return this.datasource.post("prescriptions/create/", z.instanceof(Blob), data, {
      responseType: "blob",
    });
  };

  signPrescription = (data: GeneratePrescriptionData): Promise<FileModel> => {
    return this.datasource.post("prescriptions/sign/", fileSchema, data);
  };
}
